import st from "@/styles/Ui.module.scss"
import {useTranslation} from "react-i18next";
import WarningIcon from "@/svg/WarningIcon.tsx";
import {useEffect, useRef, useState} from "react";
import {isMobile} from "react-device-detect";
import {MobileAppDwnStores} from "@/types_and_interfaces/types.ts";
import Button from "@/ui/Button.tsx";
import useCommon from "@/hooks/common.ts";
import {CircularProgress} from "@mui/joy";
import Images from "@/utils/images.ts";
import jsQR from "jsqr";
import clsx from "clsx";
import CMS from "@/utils/cms.ts";
import {spare_phone_number} from "@/utils/constants.ts";

interface Props {
    cam_bad_quality?:boolean
}

const CameraWarns:React.FC<Props> = ({cam_bad_quality}) => {
    
    const {t} = useTranslation()
    const common = useCommon()
    const effect_ran = useRef(false)
    const [markets_qr, set_markets_qr] = useState<any>(undefined)
    const is_markets = Array.isArray(markets_qr) && markets_qr.length
    const [loading, set_loading] = useState<boolean>(true)
    const getQRs = async () => {
        set_loading(true)
        const data = await common.getMarketsQrCOdes()
        const list:any = []
        
        const label_factory = (l:string):MobileAppDwnStores => {
            if(l === "apple_store") return "AppStore"
            else if(l === "huawei_store") return "AppGallery"
            else if(l === "play_store") return "PlayMarket"
            else return "PlayMarket"
        }
        
        if(typeof data === "object") {
            Object.keys(data).map((k) => {
                
                list.push({
                    qr_code: "data:image/jpeg;base64," + data[k],
                    label: label_factory(k),
                    // @ts-ignore
                    img: Images.apps[label_factory(k)]
                })
            })
        }
        
        set_markets_qr(list)
        // set_markets_qr([])
        set_loading(false)
    }
    
    useEffect(() => {
        if(!effect_ran.current) {
            getQRs()
        }
        
        return () => {
            effect_ran.current = true
        }
    }, []);
    
    return (
        <div className={st.no_camera_warn}>
            
            {cam_bad_quality ? (
                <></>
            ) : (
                <>
                    
                    <div className={st.warning_mess}>
                        {loading ? (
                            <div style={{minWidth: "100%"}}>
                                {t("camera_search")}
                            </div>
                        ) : (
                            <>
                                <WarningIcon />
                                {t("no_camera")}
                            </>
                        )}
                    </div>
                    
                    {is_markets ? (
                        <strong>
                            {t("switch_phone_for_cam")}
                        </strong>
                    ) : null}
                
                </>
            
            )}
            {loading ? (
                <div className={st.loading}>
                    <CircularProgress color={"success"} />
                </div>
            ) : (
                <>
                    {is_markets ? (
                        <MobileAppDwn markets_qr={markets_qr} />
                    ) : (
                        <strong
                            className={st.call_us}
                            dangerouslySetInnerHTML={{
                                __html: t("app_identify_difficulty").replace(/{{number}}/g, CMS?.general_info?.phone_number || spare_phone_number)
                            }}
                        />
                       
                    )}
                </>
            )}
        
        
        </div>
    )
}


interface MobileAppProps {
    markets_qr:any
}


const MobileAppDwn:React.FC<MobileAppProps> = ({markets_qr}) => {
    
    const {t} = useTranslation()
    // const { qr_code } = CMS.app_links

    
    return (
        <div className={st.app_steps}>
            
            {/*{markets_qr ? (*/}
            {/*    <>*/}
            {/*        {list.map((item: SwitchToAppStep, i: number) => {*/}
            {/*            */}
            {/*            const {text, component} = item*/}
            {/*            */}
            {/*            return (*/}
            {/*                <div className={st.app_step_item} key={`SwitchToAppStep_${i}`}>*/}
            {/*                    */}
            {/*                    <span className={st.inf}>*/}
            {/*                        {text}*/}
            {/*                    </span>*/}
            {/*                    */}
            {/*                    {component}*/}
            {/*                */}
            {/*                </div>*/}
            {/*            )*/}
            {/*        })}*/}
            {/*    </>*/}
            {/*) : <CircularProgress color={"success"}/>}*/}
            
            <div className={clsx(st.app_step_item, isMobile && st.is_mobile)}>
                {markets_qr ? (
                    <>
                        <span className={st.inf}>
                            {t("app_instruction_step1")}
                        </span>
                        
                        <AppsDwnBlocks app_links_list={markets_qr}/>
                        
                    </>
                ) : (
                    <div className={st.loading_component}>
                        <CircularProgress color={"success"}/>
                    </div>
                )}
            
            </div>
        
        
        </div>
    )
    
}

interface AppsDwnBlocksInterface {
    app_links_list: any
}

const AppsDwnBlocks: React.FC<AppsDwnBlocksInterface> = ({app_links_list}) => {
    
    
    const get_app_dwn = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        let type: MobileAppDwnStores | "" = ""
        
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            type = "AppStore"
        } else if (/Huawei/i.test(navigator.userAgent) && (userAgent.includes('huawei') || userAgent.includes('honor'))) {
            type = "AppGallery"
        } else if (/Android/i.test(navigator.userAgent) && !/Huawei/i.test(navigator.userAgent)) {
            type = "PlayMarket"
        }
        
        let obj = app_links_list.find((x:any) => x.label === type)
        
        if(obj) {
            const image = new Image();
            image.src = obj.qr_code;
            
            image.onload = () => {
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                if (!context) return;
                
                canvas.width = image.width;
                canvas.height = image.height;
                context.drawImage(image, 0, 0);
                
                const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);
                
                if (code) {
                    obj.qr_code_data = code.data
                } else {
                    obj.qr_code_data = ""
                }
            };
            
            image.onerror = () => {
                console.error(`Failed to load QR code image: ${obj.qr_code}`);
            };
        }
        
        
        return obj
    }
    
    
    if(isMobile && (typeof get_app_dwn() === "object") && Boolean(Object.keys(get_app_dwn()).length)) {
        const {img, label, qr_code_data} = get_app_dwn()
        
        
        return (
            <Button
                onClick={() => {
                    if(qr_code_data.length) {
                        window.open(qr_code_data, "_blank")
                    }
                }}
                outlined
                className={st.dwn_app_btn}
            >
                <img src={img} alt="app" />
                
                {label}
            </Button>
        )
    }
    
    if(isMobile && !Boolean(Object.keys(get_app_dwn()).length)) {
        return (Array.isArray(app_links_list) && app_links_list.length) ? (
            <div className={st.app_blocks}>
                {app_links_list.map((app_url, i:number) => {
                    
                    return <AppBlock
                        key={`app_links_list_item_${i}`}
                        app_url={app_url}
                        mobile
                    />
                })}
            </div>
        ) : null
    }
    
    return (Array.isArray(app_links_list) && app_links_list.length) ? (
        <div className={st.app_blocks}>
            {app_links_list.map((app_url, i:number) => {
                return <AppBlock key={`app_links_list_item_${i}`} app_url={app_url} />
            })}
        </div>
    ) : null
}


interface AppBlockInterface {
    app_url: any
    mobile?:boolean
}

const AppBlock:React.FC<AppBlockInterface> = ({app_url, mobile}) => {
    
    const {img, qr_code, url } = app_url
    
    return Object.keys(app_url).length ? (
        <div
            className={st.block}
            onClick={() => {
                if(mobile) {
                    window.open(url, "_blank")
                }
            }}
        >
            <img className={st.store_img} src={img} alt="app"/>
            
            {!mobile && (
                <div className={st.absolute}>
                    <img className={st.store_img} src={img} alt="app"/>
                    <img className={st.qr_img} src={qr_code} alt="app"/>
                </div>
            )}
        
        </div>
    ) : null
}

export default CameraWarns